import { buildHeaders, cartIdHeader } from "@wff/configs/HeadersConfig";
import { ICartApiResponse, IUpdateCartQtyPayload } from "@wff/interfaces";
import api from "../api";
import RestEndpoints from "../constants/RestEndpoints";

export const updateCartQtyApi = (payload: IUpdateCartQtyPayload) => {
  const headers = buildHeaders(cartIdHeader);

  return api.post<ICartApiResponse>(
    `${RestEndpoints.CART.UPDATE_ITEM}/${payload.lineItemId}`,
    {
      sku: payload.sku,
      quantity: payload.quantity,
    },
    { headers }
  );
};
